import { useMutation } from 'react-query';
import { offersService, removeCache } from '../../../services';
import { IdProps, OfferConfirmProps, SendOfferProps } from '../../../types';

export const useOfferConfirmPaymentMutation = () => {
  return useMutation(
    (props: OfferConfirmProps[]) => {
      return offersService.confirmPayment(props);
    },
    {
      onSettled: () => {
        removeCache(['container', 'gate-in', 'gate-out', 'sale', 'inventory', 'key']);
      },
    },
  );
};

export const useOfferConfirmMutation = () => {
  return useMutation(
    (props: OfferConfirmProps) => {
      return offersService.confirm(props);
    },
    {
      onSettled: () => {
        removeCache(['sale', 'inventory', 'key']);
      },
    },
  );
};

export const useOfferUpdateMutation = () => {
  return useMutation(
    (props: SendOfferProps) => {
      return offersService.update(props);
    },
    {
      onSuccess: () => {
        removeCache(['sale', 'key']);
      },
    },
  );
};

export const useCancelOfferMutation = () => {
  return useMutation(
    (props: IdProps[]) => {
      return offersService.cancel(props);
    },
    {
      onSuccess: () => {
        removeCache(['sale', 'key']);
      },
    },
  );
};

export const useCancelPaidOfferMutation = () => {
  return useMutation(
    (props: IdProps) => {
      return offersService.cancelPaid(props);
    },
    {
      onSuccess: () => {
        removeCache(['container', 'gate-in', 'gate-out', 'sale', 'inventory', 'key']);
      },
    },
  );
};
